import { ICommonRequest } from "../../model/request/ICommonRequest";
import { IDonHangChiTiet } from "../../model/respone/don-hang/IDonHangChiTiet";
import { apiClient } from "../apiClient";

export const DON_HANG_CHI_TIET_API_RESOURCE = "don-hang-chi-tiet"
export const donHangChiTietApi = {
    SelectAll: (payload:ICommonRequest) => apiClient.post(`${DON_HANG_CHI_TIET_API_RESOURCE}/select-all`,payload),
    GetByDonHang: (id: number) => apiClient.get(`${DON_HANG_CHI_TIET_API_RESOURCE}/don-hang/${id}`),
    Insert: (payload: IDonHangChiTiet) => apiClient.post(`${DON_HANG_CHI_TIET_API_RESOURCE}`, payload),
    Update: (payload: IDonHangChiTiet) => apiClient.put(`${DON_HANG_CHI_TIET_API_RESOURCE}`, payload),
    Delete: (id: number) => apiClient.delete(`${DON_HANG_CHI_TIET_API_RESOURCE}/${id}`),
}